import moment from 'moment';
import { IConversation, IDirectMessage } from './DirectMessagesWidget-types';

export function getUnreadMessages(conversation, userId, username): IDirectMessage[] {
    const lastReadDate = conversation.users.find(user => user.id === userId)?.ConversationUserResource?.lastRead;
    const unreadMessages: IDirectMessage[] = [];

    for (const message of conversation.messages) {
        if (message.user.username !== username &&
            (!lastReadDate || (lastReadDate && moment(message.createdAt).isAfter(lastReadDate)))
        ) {
            unreadMessages.push(message);
        }
    }

    return unreadMessages;
}

export function getAllUnreadMessages(conversations, userId, username) {
    let unreadMessages: IDirectMessage[] = [];

    conversations.map((conversation) => {
        unreadMessages = unreadMessages.concat(getUnreadMessages(conversation, userId, username));
    });

    return unreadMessages;
}

export function sortConversations(conversationA: IConversation, conversationB: IConversation) {
    const lastUpdateDateA = conversationA.messages[conversationA.messages.length - 1]?.createdAt ?? conversationA.createdAt;
    const lastUpdateDateB = conversationB.messages[conversationB.messages.length - 1]?.createdAt ?? conversationB.createdAt;

    return moment(lastUpdateDateB).unix() - moment(lastUpdateDateA).unix();
}

export function updateUserLastRead(user, currentUserId) {
    if (user.id === currentUserId) {
        return {
            ...user,
            ConversationUserResource: {
                ...user.ConversationUserResoure,
                lastRead: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
            },
        };
    }

    return user;
}

export function updatedConversationLastRead(conversation, conversationId, currentUserId) {
    if (conversation.id === conversationId) {
        return {
            ...conversation,
            users: conversation.users.map(user => updateUserLastRead(user, currentUserId)),
        };
    }

    return conversation;
}
